import React from 'react';
function CategoryCard({ name, src, bg }) {
  return (
    <div
      className={`${bg} shadow-md drop-shadow-sm md:w-[250px] md:h-[120px] w-[80px] h-[100px] rounded-lg`}
    >
      <div className="flex flex-col lg:flex-row lg:justify-around gap-2  items-center p-6 rounded-[20px]">
        <img
          src={src}
          alt=""
          className="lg:w-[80px] w-[40px] lg:h-[80px] h-[40px]"
        />
        <h5 className="text-dark-3 lg:text-lg text-[11px] leading-tight font-semibold mb-2 ">
          {name}
        </h5>
      </div>
    </div>
  );
}

export default CategoryCard;
